import { addDays, set } from 'date-fns';

export function getDefaultSearchDateAndTime(now: Date) {
  // If current time is more than 20:00, we init to day after at 18:00
  if (now.getHours() >= 22) {
    const dayAfter = addDays(now, 1);
    return set(dayAfter, { hours: 12, minutes: 0, seconds: 0, milliseconds: 0 });
  } else if (now.getHours() < 8) {
    // If current time is before 08:00 AM, we init to 8 AM
    return set(now, { hours: 8, minutes: 0, seconds: 0, milliseconds: 0 });
  }

  // Init to current time + two hours
  const currDateAndTime = set(now, {
    hours: now.getHours() + 1,
    minutes: ((Math.ceil(now.getMinutes() / 15) * 15) % 60) + 15,
    seconds: 0,
    milliseconds: 0,
  });

  return currDateAndTime;
}
